<script setup lang="ts">
import UserMenuItems from '@/components/user/header/UserMenuItems.vue';
import Breadcrumbs from '@/components/base/Breadcrumbs.vue';

const { isUserV2Enabled } = useFeatureFlagsJson();
</script>

<template>
  <UserV2ScreenProfile v-if="isUserV2Enabled" />
  <template v-else>
    <Breadcrumbs />
    <UserMenuItems class="mx-auto" />
  </template>
</template>
